export const iconFontAwesomeMapsMoneyBill = (
	<i className="fa-solid fa-money-bill"></i>
);
